import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MainLayout } from './components/Layout';
import Home from './pages/Home';
import Installation from './pages/Installation';
import Usage from './pages/Usage';
import { ModuleIntro } from './components/ModuleIntro';
import { ShieldCheck, Eye } from 'lucide-react';

const App: React.FC = () => {
  return (
    <Router>
      <MainLayout>
        <Routes>
          {/* Default Redirect to first project */}
          <Route path="/" element={<Navigate to="/collector" replace />} />

          {/* Collector Project Routes */}
          <Route path="/collector">
            <Route index element={<Home />} />
            <Route path="installation/nodejs" element={<Installation />} />
            <Route path="installation/springboot" element={<Installation />} />
            <Route path="installation/other" element={<Installation />} />
            <Route path="guides/express" element={<Usage />} />
            <Route path="guides/logging" element={<Usage />} />
            <Route path="guides/security" element={<Usage />} />
          </Route>

          {/* Cyxor Guard Project Routes */}
          <Route path="/guard">
            <Route index element={
              <ModuleIntro 
                 title="Guard" 
                 subtitle="Real-time threat detection & response." 
                 description="Active monitoring for cloud-native infrastructure, VPC flow logs, and intrusion detection system." 
                 icon={ShieldCheck} 
                 color="#3b82f6" 
                 comingSoon={true} 
              />
            } />
            <Route path="setup/:sub" element={<div>Guard Setup Progress...</div>} />
          </Route>

          {/* AI Auditor Project Routes */}
          <Route path="/auditor">
            <Route index element={
              <ModuleIntro 
                 title="Auditor" 
                 subtitle="Automated compliance auditing powered by AI." 
                 description="LLM-driven security verification and automated report generation for SOC2, HIPAA, and GDPR." 
                 icon={Eye} 
                 color="#10b981" 
                 comingSoon={true} 
              />
            } />
            <Route path="reports/:sub" element={<div>Auditor Reporting View...</div>} />
          </Route>

          {/* 404 Fallback */}
          <Route path="*" element={<Navigate to="/collector" replace />} />
        </Routes>
      </MainLayout>
    </Router>
  );
};

export default App;
